var validate = {
    isValidEmail: function(email) {
        return new RegExp('^\\w+([\\.-]?\\w+)*@\\w+([\\.-]?\\w+)*(\\.\\w{2,})+$').test(email);
    },

    isNotEmpty: function(value) {
        return value ? true : false;
    },

    isValidStreetAddress: function(value) {
        return new RegExp('^\\d+(\\s{1}\\w+)+$').test(value);
    },

    isValidNumber: function(num, minLength, maxLength) {
        var isValid;

        if (minLength >= 0 && maxLength >= 0) {
            isValid = new RegExp('^\\d{' + minLength + ',' + maxLength + '}$').test(num);
        } else {
            isValid = new RegExp('^\\d+$').test(num);
        }

        return isValid;
    },

    isValidString: function(str, minLength, maxLength) {
        var isValid;

        if (minLength >= 0 && maxLength >= 0) {
            isValid = new RegExp('^[\\d\\w]{' + minLength + ',' + maxLength + '}$').test(str);
        } else {
            isValid = new RegExp('^[\\d\\w]+$').test(str);
        }

        return isValid;
    },

    isContaining: function(string, match) {
        return new RegExp(match).test(string);
    },

    isMatching: function(string, match) {
        return new RegExp('^' + string + '$').test(match);
    },

    isValidPin: function(pin, ssn, minLength, maxLength) {
        var isValid;
        var reverseString = function(string) {
            var result = '';
            for (var i = string.length - 1; i >= 0; i--) {
                result += string[i];
            }
            return result;
        };
        var pin2 = reverseString(pin);

        if (minLength >= 0 && maxLength >= 0) {
            isValid = this.isValidNumber(pin, minLength, maxLength);
        } else {
            isValid = this.isValidNumber(pin, 4, 4);
        }

        /* checks if pin contains last 4 digits of ssn */
        if (ssn && isValid) {
            isValid = !this.isContaining(pin, ssn.slice(-4)) && !this.isContaining(pin2, ssn.slice(-4));
        }

        /* checks for 4 repeating numbers */
        if (isValid) {
            isValid = !new RegExp('(\\d)\\1{3,3}').test(pin);
        }

        /* checks for sequential numbers */
        if (isValid) {
            isValid = '0123456789876543210'.indexOf(pin) === -1;
        }

        return isValid;
    },

    isValidDate: function(date, minLength, maxLength) {
        return new RegExp('^(0[1-9]|1[012])[/](0[1-9]|[12][0-9]|3[01])[/](19|20)\\d\\d$').test(date);
    }
};

export default validate;



// WEBPACK FOOTER //
// ./src/js/utils/validate.js